import { apiGet, apiPost } from './client';

export interface AuthUser {
  id: string;
  email: string;
  displayName: string;
  givenName: string;
  tenantId: string;
  orgId: string | null;
  tier: 'system_admin' | 'org_admin' | 'subscriber' | 'member';
  /** @deprecated Use `tier` instead. Kept for one-cycle compatibility. */
  role?: string;
  scopeLevel?: 'identity' | 'register' | 'onboarding' | 'activate';
  requiredScopeLevel?: 'identity' | 'register' | 'onboarding' | 'activate';
  scopeExpansionRequired?: boolean;
  grantedScopes?: string[];
  /** True when Graph token refresh succeeded and grantedScopes is reliable. */
  scopesVerified?: boolean;
  createdAt: string;
}

interface GetUserResponse {
  user: AuthUser;
}

export async function getCurrentUser(): Promise<AuthUser> {
  const res = await apiGet<GetUserResponse>('/api/user');
  return res.user;
}

export async function getApiVersion(): Promise<{ version: string }> {
  return apiGet<{ version: string }>('/api/version');
}

export async function signOut(): Promise<void> {
  await apiPost('/auth/logout');
}

/**
 * Silently checks whether the current session is authenticated.
 * Uses a raw fetch to avoid the global 401→/login redirect in the API client.
 */
export async function checkAuthStatus(): Promise<boolean> {
  const res = await fetch('/api/user', { credentials: 'include' });
  return res.ok;
}
